/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Mapping_IncompleteInputs */

const en_sch_err_mapping_incomplete = /** @type {(inputs: Sch_Err_Mapping_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some statuses with items still have no new status. Choose one for each row.`)
};

const de_sch_err_mapping_incomplete = /** @type {(inputs: Sch_Err_Mapping_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für einige Status mit Vorgängen fehlt noch ein neuer Status. Wähle für jede Zeile einen.`)
};

/**
* | output |
* | --- |
* | "Some statuses with items still have no new status. Choose one for each row." |
*
* @param {Sch_Err_Mapping_IncompleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_mapping_incomplete = /** @type {((inputs?: Sch_Err_Mapping_IncompleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Mapping_IncompleteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_mapping_incomplete(inputs)
	return en_sch_err_mapping_incomplete(inputs)
});